import {
  conversionMap,
  kanaMap,
} from "../../../../assets/data/TkTextLableProperty";

/**
 * 全角カナを半角カナに変換する関数
 * @param str - 変換する文字列
 * @returns 半角カナに変換された文字列
 */
function convertFullWidthKanaToHalfWidth(str: string): string {
  let result = "";
  for (const char of str) {
    if (kanaMap.has(char)) {
      result += kanaMap.get(char);
    } else {
      result += char;
    }
  }
  return result;
}

const convertionBankFormat = (value: string): string => {
  let formatValue = value;
  for (const [key, value] of conversionMap) {
    formatValue = formatValue.replaceAll(key, value);
  }
  return formatValue;
};

export { convertFullWidthKanaToHalfWidth, convertionBankFormat };
